import React, { Suspense, useContext, useEffect, useState } from "react";

// packages
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lottie from "lottie-react";
import LoaderLottie from "../../../assets/lottie/LoaderLottie.json";

// store
import { Context } from "../../../contexts/Store";

// Route
import AuthRoute from "../routes/AuthRoute";
import AuthRouter from "./AuthRouter";
import AppRouter from "./AppRouter";

// hooks
import useUserValidation from "../../../hooks/useUserValidation";

// components
import UserValidationModal from "../../includes/modals/UserValidationModal";

/** Redirects /auth/login and /auth/signup to home with ?auth= so the login/register modal opens there */
function AuthToModalRedirect({ children }) {
  const location = useLocation();
  const path = location.pathname.replace(/\/+$/, "").toLowerCase();
  const search = location.search || "";

  if (path === "/auth/login") {
    const params = new URLSearchParams(search);
    const next = params.get("next");
    const to = next ? `/?auth=login&next=${encodeURIComponent(next)}` : "/?auth=login";
    return <Navigate to={to} replace />;
  }
  if (path === "/auth/signup") {
    const params = new URLSearchParams(search);
    const next = params.get("next");
    const to = next ? `/?auth=signup&next=${encodeURIComponent(next)}` : "/?auth=signup";
    return <Navigate to={to} replace />;
  }

  return children;
}

export default function MainRouter() {
  const [isLoading, setLoading] = useState(true);
  const { state, dispatch } = useContext(Context);

  // User validation hook - only validate if user is logged in
  const { 
    isUserActive, 
    validationError 
  } = useUserValidation({
    checkInterval: 30000, // Check every 30 seconds
    enabled: state.user_details && state.user_details.is_login && state.user_details.is_verified
  });

  async function fetchUserData() {
    let user_details = localStorage.getItem("user_details");
    
    if (user_details) {
      try {
        let user_details_stored = JSON.parse(user_details);
        dispatch({
          type: "UPDATE_USER",
          user_details: user_details_stored,
        });
      } catch (error) {
        console.error("Error parsing user details:", error);
        // Clear invalid data
        localStorage.removeItem("user_details");
        dispatch({
          type: "LOGOUT"
        });
      }
    } else {
      // No user details found, ensure clean state
      dispatch({
        type: "LOGOUT"
      });
    }
    
    setTimeout(() => {
      setLoading(false);
    }, 50);
  }

  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isLoading ? (
    <Lottie
      animationData={LoaderLottie}
      style={{
        height: "100vh",
        width: 150,
        margin: "auto",
      }}
    />
  ) : (
    // <h1>loading...</h1>
    <>
      <Suspense fallback={"Loading"}>
        <Routes>
          <Route
            path="auth/*"
            element={
              <AuthToModalRedirect>
                <AuthRoute>
                  <AuthRouter />
                </AuthRoute>
              </AuthToModalRedirect>
            }
          />
          <Route
            path="/*"
            element={
                <AppRouter />
            }
          />
          {/* <Route exact path="*" element={<h1>error...</h1>} /> */}
        </Routes>
      </Suspense>

      {/* Global User Validation Modal - Shows when user account is deactivated */}
      <UserValidationModal
        isOpen={!isUserActive && state.user_details && state.user_details.is_login && state.user_details.is_verified}
        message={validationError || "Your account has been deactivated or deleted by admin."}
      />
    </>
  );
}
